<template>
	<MainContainer hideHeader hideFooter :loading="state.loading">
		<AuthHeader show-back @back="onBackClick" />
		<div class="flex flex-col flex-grow px-5 pb-5">
			<AuthCard
				v-model:page="state.page"
				v-model:loading="state.loading"
				v-model:mode="state.mode"
				hide-back
				class="flex-grow"
			/>
		</div>
	</MainContainer>
</template>

<script setup lang="ts">
import { UserAuthMode } from '~/stores/user';

definePageMeta({
	middleware: ["noauth"]
})

const app = useNuxtApp()
const route = useRoute()

const state = reactive({
	loading: false,
	page: "login-1" as any,
	mode: "email" as UserAuthMode["id"]
})

const onBackClick = () => {
	if (state.page == "user-2") {
		state.page = "login-1"
	} else if (state.page == "verify-user") {
		state.page = "login-1"
	} else if (state.page == "forget-password") {
		state.page = "login-1"
	} else if (state.page == "verify-forget") {
		state.page = "login-1"
	} else {
		app.$backWithFallback(app.$routeUrl.AuthStartUrl())
	}
}

onMounted(() => {
	if (Number(route.query.login)) {
		state.page = "login-1"
	} else if (Number(route.query.register)) {
		state.page = "register"
	}
})
</script>
